import { Container } from 'src/shared/design-system/Layout';
import { InfoIcon } from 'src/shared/design-system/Tooltip';
import { ZIndexes } from 'src/shared/ZIndexes';
import styled, { css } from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import { FilterButton } from './FilterButton';
import { DropdownContainer } from './FilterSelector';

export const FiltersRowBackground = styled.div<{ offsetTop: number }>`
  width: 100%;
  background-color: ${Colors.WHITE};
  position: sticky;
  top: ${(props) => props.offsetTop}px;
  z-index: ${ZIndexes.SegmentFiltersContainer};

  @media (max-width: ${ScreenWidth.SMALL}) {
    overflow-x: scroll;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
    overscroll-behavior: contain;
  }
`;

export const ProminentDateFiltersRowWrapper = styled(Container)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  padding: ${Spacing.SINGLE} 14px;

  @media (min-width: ${ScreenWidth.SMALL}) {
    width: 750px;

    padding: ${Spacing.SINGLE} ${Spacing.SINGLE} ${Spacing.SINGLE_HALF};
  }

  @media (min-width: ${ScreenWidth.LARGE}) {
    width: 1140px !important;
  }

  ${DropdownContainer} {
    right: 0;
  }
`;

export const FiltersRowWrapper = styled(Container)`
  padding-left: ${Spacing.SINGLE};
  padding-bottom: 15px;

  display: flex;
  align-items: center;

  padding-top: ${Spacing.SINGLE};
  @media (max-width: ${ScreenWidth.SMALL}) {
    width: max-content;

    justify-content: flex-start;
    padding-bottom: ${Spacing.SINGLE_HALF};
  }
`;

export const FilterSelectorWrapper = styled.div`
  position: relative;
  margin-right: 10px;
  @media (max-width: ${ScreenWidth.SMALL}) {
    margin-right: ${Spacing.HALF};
  }
`;

export const DateLabel = styled.span`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  font-size: ${Font.Size.M};
  line-height: ${Font.Size.M};
  color: ${Colors.GRAY_DARK_30};
  margin-right: ${Spacing.HALF};
`;

export const FilterLabel = styled.span`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  font-size: ${Font.Size.M};
  line-height: ${Font.Size.M};
  color: ${Colors.GRAY_DARK_30};
  margin-left: auto;
  margin-right: ${Spacing.HALF};
`;

export const TooltipTextWrapper = styled.span`
  font-family: ${Font.Family.SANS};
  font-style: normal;
  font-weight: normal;
  color: ${Colors.GRAY_DARK_10};
  font-size: ${Font.Size.M};
  line-height: ${Font.Size.M};

  ${InfoIcon} {
    vertical-align: top;
  }
`;

export const TooltipText = styled.span`
  font-size: ${Font.Size.XS};
  line-height: ${Font.Size.XS};
  margin-right: ${Spacing.QUARTER};
  vertical-align: middle;

  @media (max-width: ${ScreenWidth.SMALL}) {
    display: none;
  }
`;

export const FilterIconWrapper = styled.div`
  background-color: ${Colors.WHITE};
  border-radius: 100%;
  width: 24px;
  height: 24px;
  margin-right: ${Spacing.HALF};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FilterIcon = styled.img<{ inverted?: boolean }>`
  ${(props) => {
    if (props.inverted) {
      return css`
        filter: brightness(0) saturate(100%) invert(15%) sepia(4%) saturate(0%) hue-rotate(138deg) brightness(89%)
          contrast(77%);
      `;
    }
    return '';
  }}
`;

export const IconFilterButton = styled(FilterButton)`
  padding-left: ${Spacing.QUARTER};
  padding-right: ${Spacing.THREE_QUARTERS};
`;
